module.exports = __webpack_public_path__ + "img/close-red.8d16afe1.svg";